import * as DashboardConstants from '.././DashboardConstants';

export const RemediationTableHeaders = [
    {
        key: 'Incident No.',
        header: DashboardConstants.IncidentNo,
        hidden: false,
        optional: false
    },
    {
        key: 'Client',
        header: DashboardConstants.Client,
        hidden: true,
        optional: true
    },
    {
        key: 'Process',
        header: DashboardConstants.Process,
        hidden: false,
        optional: false
    },
    {
        key: 'Job ID',
        header: DashboardConstants.JobID,
        hidden: false,
        optional: false
    },
    {
        key: 'Associated failure job ID',
        header: DashboardConstants.AssociatedFailureJobID,
        hidden: false,
        optional: false
    },
    {
        key: 'Type',
        header: DashboardConstants.Type,
        hidden: true,
        optional: true
    },
    {
        key: 'Remediation status',
        header: DashboardConstants.RemediationStatus,
        hidden: false,
        optional: false
    },
    {
        key: 'Dur.',
        header: DashboardConstants.DuraMins,
        hidden: true,
        optional: true
    },
    {
        key: 'Updated on',
        header: DashboardConstants.UpdatedOn,
        hidden: false,
        optional: false
    }

];

export const ULLRemediationTableHeaders = [
    {
        key: 'Incident No.',
        header: DashboardConstants.IncidentNo,
        hidden: false,
        optional: false
    },
    {
        key: 'Client',
        header: DashboardConstants.Client,
        hidden: true,
        optional: true
    },
    {
        key: 'Process',
        header: DashboardConstants.Process,
        hidden: false,
        optional: false
    },
    {
        key: 'Job ID',
        header: DashboardConstants.JobID,
        hidden: false,
        optional: false
    },
    {
        key: 'Type',
        header: DashboardConstants.Type,
        hidden: true,
        optional: true
    },
    {
        key: 'Remediation status',
        header: DashboardConstants.RemediationStatus,
        hidden: false,
        optional: false
    },
    {
        key: 'Dur.',
        header: DashboardConstants.DuraMins,
        hidden: true,
        optional: true
    },
    {
        key: 'Updated on',
        header: DashboardConstants.UpdatedOn,
        hidden: false,
        optional: false
    }

];

